import { createFileRoute } from '@tanstack/react-router';

import { DepartmentBrowse } from '@/module/Department/DepartmentBrowse';

export const Route = createFileRoute('/_auth/administration/_administration/department/_department/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DepartmentBrowse />;
}
